/// <amd-module name="Agile/Sprints/Directory/DateCell" />
import { IDirectoryRow } from "Agile/Directory/Components/DirectoryGrid";
import { SetDates } from "Agile/Sprints/Directory/Resources";
import { ISprintDirectoryArtifact } from "Agile/Sprints/Directory/SprintDirectoryContracts";
import { Link } from "VSSUI/Link";
import { css } from "VSSUI/Util";
import * as React from "react";

export class DateCell extends React.PureComponent<{
    row: IDirectoryRow<ISprintDirectoryArtifact>;
    onClickSetDates: (artifact: ISprintDirectoryArtifact) => void;
}> {
    public render(): JSX.Element | null {
        const {
            row: { isDeleted, data: artifact }
        } = this.props;
        if (!isDeleted) {
            let content: string;
            const datesExist = !(!artifact.iterationStartDate || !artifact.iterationEndDate);
            if (datesExist) {
                // If either date is not in this year, then both dates will be in "Jan 01 2017" Format
                const dateFormatOptions: Intl.DateTimeFormatOptions = {
                    month: "short",
                    day: "numeric",
                    timeZone: "UTC"
                };
                const today: Date = new Date(); //getNowInUserTimeZone();
                if (
                    artifact.iterationStartDate!.getFullYear() !== today.getFullYear() ||
                    artifact.iterationEndDate!.getFullYear() !== today.getFullYear()
                ) {
                    dateFormatOptions.year = "numeric";
                }

                content = `${artifact.iterationStartDate!.toLocaleDateString(
                    undefined,
                    dateFormatOptions
                )} - ${artifact.iterationEndDate!.toLocaleDateString(undefined, dateFormatOptions)}`;
            } else {
                content = SetDates;
            }

            return (
                <Link
                    aria-label={`${datesExist ? `${content} ` : ""}Set Dates`}
                    className={css("sprint-dates", !datesExist && "sprint-dates-visible-on-hover")}
                    onClick={this._onClickSetDates}
                    tooltipProps={{ text: content, className: "flex-tooltip-host", overflowOnly: true }}
                >
                    {content}
                </Link>
            );
        }

        return null;
    }

    private _onClickSetDates = (): void => {
        const {
            onClickSetDates,
            row: { data }
        } = this.props;

        if (onClickSetDates) {
            onClickSetDates(data);
        }
    };
}
